import CloseOutlined from '@mui/icons-material/CloseOutlined';
import { Button, Chip, Grid, useTheme } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { FilterChip } from './SearchAndFilters';

interface Props {
  chips: FilterChip[];
  onClearAll?: () => void;
}

const FilterChips: React.FC<Props> = ({ chips, onClearAll }) => {
  const { translation } = useTranslation();
  const theme = useTheme();

  return (
    <Grid container spacing={1} alignItems="center" wrap="nowrap">
      {chips.map((chip) => (
        <Chip
          key={chip.label}
          label={chip.label}
          onDelete={chip.onDelete}
          deleteIcon={<CloseOutlined style={{ color: theme.palette.primary.main }} />}
          style={{
            border: `1px solid ${theme.palette.primary.main}`,
            color: theme.palette.primary.main,
            backgroundColor: 'transparent'
          }}
        />
      ))}
      {chips.length > 1 && onClearAll && (
        <Button
          id="clear-all-button"
          onClick={onClearAll}
          variant="text"
          size="small"
          sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}
        >
          {translation.clear_all}
        </Button>
      )}
    </Grid>
  );
};

export default FilterChips;
